const addPrefixApp = (key: string) => `app-${key}`;

function withPrefix<T extends Record<string, string>>(
  keys: T
): Record<keyof T, string> {
  return Object.fromEntries(
    Object.entries(keys).map(([key, value]) => [key, addPrefixApp(value)])
  ) as Record<keyof T, string>;
}

const aulasKeys = {
  AULAS_TEORICAS: 'aulas-teoricas',
  AULAS_PRATICAS: 'aulas-praticas',
  AULAS_SIMULADOR: 'aulas-simulador',
  DESMARCAR_AULAS_PRATICAS: 'desmarcar-aulas-praticas',
} as const;

const alunoKeys = {
  ALUNO_PARCELAS: 'aluno-parcelas',
  ALUNO_PARCELA_DETALHE: 'aluno-parcela-detalhe',
  ALUNO_GERAR_COBRANCA: 'aluno-gerar-cobranca',
  ALUNO_FINANCEIRO_DETALHE: 'aluno-financeiro-detalhe',
  ALUNO_AGENDAMENTOS_EXAMES_PRATICOS: 'aluno-agendamentos-exames-praticos',
  ALUNO_LADVS: 'aluno-ladvs',
  ALUNO_COMUNICADOS: 'aluno-comunicados',
  ALUNO_CONTRATO: 'aluno-contrato',
  ALUNO_DETALHE: 'aluno-detalhe',
  ALUNO_TELEFONES: 'aluno-telefones',
  ALUNO_ENDERECO: 'aluno-endereco',
  ALUNO_LADV: 'aluno-ladv',
  ALUNO_LOGIN: 'aluno-login',
  ALUNO_AULAS_PRATICAS: 'aluno-aulas-praticas',
} as const;

const autoescolaKeys = {
  AUTOESCOLA_TEMPLATES_MARKETING: 'autoescola-templates-marketing',
  AUTOESCOLA_TEMPLATES_MARKETING_DEFAULT:
    'autoescola-templates-marketing-default',
  AUTOESCOLA_TEMPLATES_MARKETING_EXCLUIR:
    'autoescola-templates-marketing-excluir',
} as const;

const prodespKeys = {
  PROTOCOLOS_PRODESP: 'protocolos-prodesp',
} as const;

const safeToPayKeys = {
  SAFE_TO_PAY_DEPOSITOS_MES: 'safe-to-pay-depositos-mes',
  SAFE_TO_PAY_DEPOSITO_DETALHE: 'safe-to-pay-deposito-detalhe',
} as const;

const unidadeKeys = {
  UNIDADE_ALL_DATA: 'unidade-all-data',
  UNIDADE_AULA_PRATICA_DIA: 'unidade-aula-pratica-dia',
  UNIDADE_AULAS_REALIZADAS_MES: 'unidade-aulas-realizadas-mes',
  UNIDADE_ALUNOS_COM_DEBITOS: 'unidade-alunos-com-debitos',
  UNIDADE_EXAMES_PRATICOS_DIA: 'unidade-exames-praticos-dia',
  UNIDADE_RECIBOS_PERIODO: 'unidade-recibos-periodo',
  UNIDADE_CONTAS_BANCARIAS: 'unidade-contas-bancarias',
  UNIDADE_DESPESAS_RECEITAS: 'unidade-despesas-receitas',
  UNIDADE_DESPESAS_MIN: 'unidade-despesas-min',
  UNIDADE_DEPOSITOS_DIA: 'unidade-depositos-dia',
  UNIDADE_MATRICULAS_PERIODO: 'unidade-matriculas-periodo',
  UNIDADE_MATRICULAS_ULTIMOS_SEIS_MESES:
    'unidade-matriculas_ultimos_seis_meses',
  UNIDADE_MATRICULAS_POR_CEP: 'unidade-matriculas-por-cep',
  UNIDADE_MATRICULAS_A_VENCER: 'unidade-matriculas-a-vencer',
  UNIDADE_NFS_EMITIDAS: 'unidade-nfs-emitidas',
  UNIDADE_CONTRATOS_ONLINE: 'unidade-contratos-online',
  UNIDADE_ORCAMENTOS_STATUS: 'unidade-orcamentos-status',
  UNIDADE_ORCAMENTO_USUARIO_TOP: 'unidade-orcamento-usuario-top',
  UNIDADE_ORCAMENTO_MARKETING_TOP: 'unidade-orcamento-marketing-top',
  UNIDADE_DESPESAS_RECEITAS_HOME: 'unidade-despesas-receitas-home',
  UNIDADE_BY_CPF_ALUNO: 'unidade-by-cpf-aluno',
} as const;

const atendenteKeys = {
  ATENDENTE_CONTATO: 'atendente-contato',
} as const;

const instrutorKeys = {
  INSTRUTOR_DIAS_PERMITIDOS: 'instrutor-dias-permitidos',
  INSTRUTOR_BY_ID: 'instrutor-by-id',
} as const;

const metasKeys = {
  UNIDADE_METAS_MATRICULAS_ABERTAS: 'unidade-metas-matriculas-abertas',
} as const;

export const queryKeys = {
  ...withPrefix(aulasKeys),
  ...withPrefix(alunoKeys),
  ...withPrefix(autoescolaKeys),
  ...withPrefix(prodespKeys),
  ...withPrefix(safeToPayKeys),
  ...withPrefix(unidadeKeys),
  ...withPrefix(atendenteKeys),
  ...withPrefix(instrutorKeys),
  ...withPrefix(metasKeys),
};
